import i18n from '@/i18n/i18n'

export interface ValidationRule {
  (value: any): boolean | string
}

export const textIsNotEmpty: ValidationRule = <T>(value: T) => {
  if (!value) return i18n.global.t('Please provide a value')
  const textOnly = String(value)
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, '')
    .trim()

  if (!textOnly) return i18n.global.t('Please provide a value')

  return true
}

export const minLengthRule =
  (minLength: number): ValidationRule =>
  (value: string) =>
    !value ||
    value.length >= minLength ||
    `${i18n.global.t('Minimum')} ${minLength} ${i18n.global.t('characters required')}`

export const maxLengthRule =
  (maxLength: number): ValidationRule =>
  (value: string) =>
    !value ||
    value.length <= maxLength ||
    `${i18n.global.t('Maximum')} ${maxLength} ${i18n.global.t('characters allowed')}`

export const alphanumericRule: ValidationRule = (value: string) =>
  !value || /^[\p{L}\d\s]*$/u.test(value) || i18n.global.t('Only letters and numbers are allowed')
